import React from 'react';
import PropTypes from 'prop-types';

import { fnChildrenPropType } from '../../../utils/customPropTypes';

/**
 * Responsible for basic page layout with title and content area.
 *
 * @param {object} props - The props passed to this component.
 * @param {string} props.sTitle - The title to be displayed.
 * @param {array} props.children - The children of this component.
 *
 * @author Elizabeth Hicks <hicksem@wfu.edu>
 * @copyright 2022 Wake Forest University, AIT
 */
const PageLayout = ({ sTitle, children, bHasBackground, className }) => (
  <div className={`pageLayout ${className}`}>
    <h1 className='pageLayout__title'>{sTitle}</h1>
    <div
      className={`pageLayout__content${bHasBackground ? '--background' : ''}`}
    >
      {children}
    </div>
  </div>
);

PageLayout.propTypes = {
  sTitle: PropTypes.string.isRequired,
  children: fnChildrenPropType.isRequired,
  bHasBackground: PropTypes.bool,
  className: PropTypes.string,
};

PageLayout.defaultProps = {
  bHasBackground: true,
  className: '',
};

export default PageLayout;
